/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizeraboutenglish2Inputs */

const en_organizeraboutenglish2 = /** @type {(inputs: Organizeraboutenglish2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In English`)
};

const de_organizeraboutenglish2 = /** @type {(inputs: Organizeraboutenglish2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Englisch`)
};

/**
* | output |
* | --- |
* | "In English" |
*
* @param {Organizeraboutenglish2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizeraboutenglish2 = /** @type {((inputs?: Organizeraboutenglish2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizeraboutenglish2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizeraboutenglish2(inputs)
	return de_organizeraboutenglish2(inputs)
});
export { organizeraboutenglish2 as "organizerAboutEnglish" }